import React from 'react';

import { closeRemixModal } from './editor-commands/close-remix-modal';
import { openRemixModal } from './editor-commands/open-remix-modal';
import type { MalleableUiPlugin } from './malleableUiPluginType';
import { createMalleableUiPmPlugin, malleableUiPluginKey } from './pm-plugins/plugin-key';
import { RemixContent } from './ui/components/RemixContent';
import { getOverriddenFloatingToolbarConfig } from './ui/toolbars/overridden-floating-toolbar-config';
import { getSelectionToolbarComponents } from './ui/toolbars/toolbar-components';

export const malleableUiPlugin: MalleableUiPlugin = ({ api, config }) => {
	api?.toolbar?.actions.registerComponents(getSelectionToolbarComponents(api));

	return {
		name: 'malleableUi',

		pmPlugins() {
			return [
				{
					name: 'malleableUi',
					plugin: ({ dispatch }) => createMalleableUiPmPlugin(dispatch),
				},
			];
		},

		getSharedState(editorState) {
			if (!editorState) {
				return undefined;
			}
			return malleableUiPluginKey.getState(editorState);
		},

		commands: {
			openRemixModal,
			closeRemixModal,
		},

		contentComponent: () => {
			return <RemixContent api={api} config={config} />;
		},

		pluginsOptions: {
			floatingToolbar: getOverriddenFloatingToolbarConfig(api),
		},
	};
};
